/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'zoomin': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<g _fill="#000" fill-rule="evenodd"><path pid="0" d="M4.214 14.27a7.064 7.064 0 01-2.082-5.028c0-1.9.74-3.685 2.082-5.028a7.064 7.064 0 015.028-2.082c1.9 0 3.685.74 5.028 2.082a7.064 7.064 0 012.082 5.028c0 1.9-.74 3.685-2.082 5.028a7.064 7.064 0 01-5.028 2.082c-1.9 0-3.685-.74-5.028-2.082zM24 21.74l-7.191-7.192a9.173 9.173 0 001.675-5.306c0-2.469-.961-4.79-2.707-6.535A9.181 9.181 0 009.242 0c-2.469 0-4.79.961-6.535 2.707A9.181 9.181 0 000 9.242c0 2.469.961 4.79 2.707 6.535a9.182 9.182 0 006.535 2.707 9.173 9.173 0 005.306-1.675L21.739 24 24 21.74z"/><path pid="1" d="M10.235 4.941H8.118v3.177H4.94v2.117h3.177v3.177h2.117v-3.177h3.177V8.118h-3.177V4.94"/></g>'
  }
})
